import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { PaginationViewModel } from '../../models/view/pagination';
import { debounceTime } from 'rxjs/operators';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent implements OnInit {

    @Output() getPaginationEmitter: EventEmitter<object> = new EventEmitter<object>();
    @Input() pagination: PaginationViewModel = new PaginationViewModel();

    data: PaginationViewModel = new PaginationViewModel();

    paginationForm: FormGroup;

    constructor(
        private formBuilder: FormBuilder
    ) {
        this.initForm();
    }

    ngOnInit() {
        this.onInputChange();
    }

    initForm() {
        this.paginationForm = this.formBuilder.group({
            current_page: ['', [Validators.required, Validators.pattern('[0-9]+')]],
        });
    }

    /**
     * On input change value emmit event setPage
     */
    onInputChange() {
        this.paginationForm.get('current_page').valueChanges.pipe(debounceTime(400)).subscribe(() => {
            this.setPage(this.pagination.current_page);
        });
    }

    /**
     * Set the current_page value
     * @param page Display active page in component
     */
    setCurrentPage(page: any, operation?: string) {

        if (operation !== null) {
            if (operation === '+') {
                page = parseInt(page) + 1;
            } else if (operation === '-') {
                page = parseInt(page) - 1;
            }
        }

        if (page < 1) {
            page = 1;
        } else if (page > this.pagination.last_page) {
            page = this.pagination.last_page;
        }

        this.paginationForm.controls['current_page'].setValue(page);
    }

    /**
     * Set the current page label
     * @param page Display active page in component
     */
    setPage(page: any) {

        this.data.current_page = parseInt(page);

        // Get Total
        this.pagination.last_page = Math.ceil(this.pagination.total_items / this.pagination.items_per_page);

        if (this.pagination.last_page === 0) {
            this.pagination.last_page = 1;
        }

        // Set Page
        if (this.pagination.current_page < 1) {
            this.pagination.current_page = 1;
        } else if (this.pagination.current_page > this.pagination.last_page) {
            this.pagination.current_page = this.pagination.last_page;
        }

        // Has Next Page
        if (this.pagination.current_page < this.pagination.last_page) {
            this.pagination.has_next_page = true;
        } else {
            this.pagination.has_next_page = false;
        }

        // Has Previous Page
        if (this.pagination.current_page > 1) {
            this.pagination.has_previous_page = true;
        } else {
            this.pagination.has_previous_page = false;
        }

        // Data
        this.data.items_per_page = this.pagination.items_per_page;
        this.data.total_items = this.pagination.total_items;
        this.data.last_page = this.pagination.last_page;
        this.data.has_next_page = this.pagination.has_next_page;
        this.data.has_previous_page = this.pagination.has_previous_page;

        this.getPaginationEmitter.emit(this.data);

    }

}

export { PaginationViewModel };